import axios from 'axios';

export default axios.create({
    baseURL: 'https://intrates.v3.voice.weepee.io/publicapi/1dd67a47f83f4527b686bf5f47b786af'
});

